export default __webpack_public_path__ + "static/michigan-5-76befd050876e7708d4171f4d3dd519b.jpg";